module.exports = __webpack_public_path__ + "static/media/earncmecredit.11bf2d7a.png";